// Configuration file for application settings

// Define configuration interface
export interface Config {
  baseUrl: string;
  discordApiUrl: string;
  flaskApiUrl: string;
  debug: boolean;
  environment: string;
  isServer: boolean;
  isClient: boolean;
}

// Environment detection
const isServer = typeof window === 'undefined';
const isClient = !isServer;
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// Safely get API URL from window only on the client side
const getDiscordApiUrl = (): string => {
  if (isClient && (window as any).API_URL) {
    return (window as any).API_URL;
  }
  return 'https://systemsadmin-vak.com/';
};

// Safely get base URL from environment or current origin
const getBaseUrl = (): string => {
  let baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
  
  if (baseUrl && baseUrl.includes(',')) {
    // Split by comma and trim whitespace
    const baseUrls = baseUrl.split(',').map(url => url.trim());
    
    // If we're on the client side, try to match the current origin
    if (isClient) {
      const currentOrigin = window.location.origin;
      const matchingUrl = baseUrls.find(url => url.includes(currentOrigin.replace(/^https?:\/\//, '')));
      if (matchingUrl) {
        baseUrl = matchingUrl;
      } else {
        // Fallback to first URL if no match
        baseUrl = baseUrls[0];
      }
    } else {
      // Server-side fallback to first URL
      baseUrl = baseUrls[0];
    }
  }
  
  // Fallback logic if no baseUrl is set
  if (!baseUrl) {
    if (isDevelopment) {
      return 'http://localhost:3000';
    } else if (isClient) {
      return window.location.origin;
    } else {
      // Server-side fallback
      return process.env.VERCEL_URL ? `https://${process.env.VERCEL_URL}` : 'https://systemsadmin-vak.com';
    }
  }
  
  return baseUrl;
};

// Create the configuration object
const config: Config = {
  // Base URL for the application
  baseUrl: getBaseUrl(),

  // Discord API URL 
  discordApiUrl: getDiscordApiUrl(),
  
  // Flask Backend API URL (for Roblox API calls)
  // Use environment variable or fallback to HTTP (for local development)
  flaskApiUrl: process.env.FLASK_API_URL || 'https://systemsadmin-vak.com/',
  
  // Debug mode (enabled in development)
  debug: isDevelopment,
  
  // Current environment
  environment: process.env.NODE_ENV || 'development',
  
  // Environment flags
  isServer,
  isClient
};

// Log config in development mode on client
if (isDevelopment && isClient) {
  console.log('Application config:', config);
}

export default config; 